/* Map Control Toggle */
jQuery(".coverage-map-ui ul li").click(function() {
	jQuery(this).toggleClass("off")
});
  
function initMap() {
     // Create a map object and specify the DOM element for display.
     var map = new google.maps.Map(document.getElementById('map'), {
         center: {
             lat: 41.2983782,
             lng: -72.9641152
         },
         scrollwheel: false,
         streetViewControl: false,
         mapTypeControl: false,
         zoom: 8,
         // Styling the map
        styles: [
					{
							"featureType": "all",
							"elementType": "labels.text.fill",
							"stylers": [
									{
											"saturation": "-100"
									},
									{
											"lightness": "0"
									},
									{
											"gamma": "2"
									}
							]
					},
					{
							"featureType": "all",
							"elementType": "labels.text.stroke",
							"stylers": [
									{
											"visibility": "off"
									}
							]
					},
					{
							"featureType": "administrative",
							"elementType": "geometry.fill",
							"stylers": [
									{
											"color": "#fefefe"
									},
									{
											"lightness": 20
									}
							]
					},
					{
							"featureType": "administrative",
							"elementType": "geometry.stroke",
							"stylers": [
									{
											"color": "#e9e9e9"
									},
									{
											"lightness": -15
									},
									{
											"weight": 2
									}
							]
					},
					{
							"featureType": "administrative",
							"elementType": "labels.icon",
							"stylers": [
									{
											"visibility": "on"
									},
									{
											"weight": "1"
									},
									{
											"gamma": "0.00"
									},
									{
											"lightness": "100"
									},
									{
											"saturation": "0"
									}
							]
					},
					{
							"featureType": "administrative.province",
							"elementType": "geometry.stroke",
							"stylers": [
									{
											"lightness": "0"
									},
									{
											"saturation": "-100"
									},
									{
											"gamma": "2"
									},
									{
											"weight": "2"
									}
							]
					},
					{
							"featureType": "landscape",
							"elementType": "geometry",
							"stylers": [
									{
											"lightness": "0"
									},
									{
											"saturation": "-100"
									},
									{
											"gamma": "5"
									}
							]
					},
					{
							"featureType": "poi",
							"elementType": "all",
							"stylers": [
									{
											"visibility": "off"
									}
							]
					},
					{
							"featureType": "road",
							"elementType": "all",
							"stylers": [
									{
											"visibility": "off"
									}
							]
					},
					{
							"featureType": "transit",
							"elementType": "all",
							"stylers": [
									{
											"visibility": "off"
									}
							]
					},
					{
							"featureType": "water",
							"elementType": "geometry.fill",
							"stylers": [
									{
											"saturation": "-100"
									},
									{
											"lightness": "0"
									},
									{
											"gamma": "1.5"
									}
							]
					}
			] //End Styles
     });// New Map

    var nccolor = '#004165';
    var ntcolor = '#9a3b26';
    var cmcolor = '#006a4d';

    var markers = {
        fairfieldfm: {
            title:'91.1 FM, Fairfield, CT',
            category: 'ALL',
            center: {lat: 41.279263, lng: -73.18539},
            coverage: {lat: 41.1925, lng: -73.1014},
            radius: 38,
            station: 'fairfieldfm',
            visible: true,
            color: nccolor
        },
        stamfordfm: {
            title:'90.1 FM, Stamford, CT',
            category: 'CT',
            center: {lat: 41.047778, lng: -73.554444},
            coverage: {lat: 41.047778, lng: -73.554444},
            radius: 3,
            station: 'stamfordfm',
            visible: true,
            color: nccolor
        },
        huntingtonfm: {
            title:'91.3 FM, Huntington Station, NY',
            category: 'NY',
            center: {lat: 40.782222, lng: -73.368056},
            coverage: {lat: 40.782222, lng: -73.368056},
            radius: 8,
            station: 'huntingtonfm',
            visible: true,
            color: nccolor
        },
        ridgefm: {
            title:'106.5 FM, Ridge, NY',
            category: 'NY',
            center: {lat: 40.855000, lng: -72.770000},
            coverage: {lat: 40.855000, lng: -72.770000},
            radius: 14,
            station: 'ridgefm',
            visible: true,
            color: nccolor
        },
        greenportfm: {
            title:'89.9 FM, Greenport, NY',
            category: 'ALL',
            center: {lat: 41.109722, lng: -72.368056},
            coverage: {lat: 41.109722, lng: -72.368056},
            radius: 35,
            station: 'greenportfm',
            visible: true,
            color: ntcolor
        },
        seldenfm: {
            title:'105.7 FM, Selden, NY',
            category: 'NY',
            center: {lat: 40.842222, lng: -73.039722},
            coverage: {lat: 40.842222, lng: -73.039722},
            radius: 20,
            station: 'seldenfm',
            visible: true,
            color: ntcolor
        },
        northfordfm: {
            title:'93.3 FM, Northford, CT',
            category: 'CT',
            center: {lat: 41.419444, lng: -72.711944},
            coverage: {lat: 41.419444, lng: -72.711944},
            radius: 11,
            station: 'northfordfm',
            visible: true,
            color: ntcolor
        },
        newhavenam: {
            title:'1340 AM, New Haven, CT',
            category: 'CT',
            center: {lat: 41.292500, lng: -72.953333},
            coverage: {lat: 41.2489, lng: -72.9035},
            radius: 20,
            station: 'newhavenam',
            visible: true,
            color: ntcolor
        },
        westportam: {
            title:'1260 AM, Westport, CT',
            category: 'CT',
            center: {lat: 41.128889, lng: -73.388889},
            coverage: {lat: 41.128889, lng: -73.388889},
            radius: 12,
            station: 'westportam',
            visible: true,
            color: ntcolor
        },
        danburyfm: {
            title:'96.1 FM, Danbury, CT',
            category: 'CT',
            center: {lat: 41.395806, lng: -73.424361},
            coverage: {lat: 41.4250, lng: -73.4500},
            radius: 6,
            station: 'danburyfm',
            visible: true,
            color: ntcolor
        },
        derbyfm: {
            title:'106.5 FM, Derby, CT',
            category: 'CT',
            center: {lat: 41.391417, lng: -73.053778},
            coverage: {lat: 41.391417, lng: -73.053778},
            radius: 6,
            station: 'derbyfm',
            visible: true,
            color: ntcolor
        },
        noyakfm: {
            title:'WSUF  HD2 (89.9 FM), Noyack, NY',
            category: 'ALL',
            center: {lat: 41.109722, lng: -72.368056},
            coverage: {lat: 41.109722, lng: -72.368056},
            radius: 10,
            station: 'noyakfm',
            visible: true,
            color: cmcolor
        },
        noyak2fm: {
            title:'107.5 FM, Noyack, NY',
            category: 'NY',
            center: {lat: 40.971944, lng: -72.348333},
            coverage: {lat: 40.971944, lng: -72.348333},
            radius: 12,
            station: 'noyak2fm',
            visible: true,
            color: cmcolor
        },
    };

    var posMarkers = {};
    var covMarkers = {};

    for (var marker in markers) {

		// Create all markers
		posMarkers[marker] = new google.maps.Marker({
			visible: markers[marker].visible,
			position: markers[marker].center,
				icon: {
					path: google.maps.SymbolPath.CIRCLE,
					scale: 2,
					fillColor: markers[marker].color,
					fillOpacity: 1,
					strokeColor: markers[marker].color
				},
				map: map,
				title: markers[marker].title,
		});
		// Create all coverage areas
		covMarkers[marker]  = new google.maps.Circle({
			visible: markers[marker].visible,
			strokeColor: markers[marker].color,
			strokeOpacity: 0.75,
			strokeWeight: 0,
			fillColor: markers[marker].color,
			fillOpacity: 0.1,
			map: map,
			center: markers[marker].coverage,
			radius: Math.round(markers[marker].radius * 1609.344)
		});
    }

    // Add Event Listeners
    google.maps.event.addDomListener(fairfieldfm, 'click', function() { for (var marker in markers) {
         if (markers[marker].station == 'fairfieldfm') {
             if (posMarkers[marker].getVisible()) { posMarkers[marker].setVisible(false); covMarkers[marker].setVisible(false); } 
             else { posMarkers[marker].setVisible(true); covMarkers[marker].setVisible(true); }
         }
    }});
    google.maps.event.addDomListener(stamfordfm, 'click', function() { for (var marker in markers) {
         if (markers[marker].station == 'stamfordfm') {
             if (posMarkers[marker].getVisible()) { posMarkers[marker].setVisible(false); covMarkers[marker].setVisible(false); } 
             else { posMarkers[marker].setVisible(true); covMarkers[marker].setVisible(true); }
         }
    }});
    google.maps.event.addDomListener(huntingtonfm, 'click', function() { for (var marker in markers) {
             if (markers[marker].station == 'huntingtonfm') {
             if (posMarkers[marker].getVisible()) { posMarkers[marker].setVisible(false); covMarkers[marker].setVisible(false); } 
             else { posMarkers[marker].setVisible(true); covMarkers[marker].setVisible(true); }
             }
    }});
    google.maps.event.addDomListener(ridgefm, 'click', function() { for (var marker in markers) {
         if (markers[marker].station == 'ridgefm') {
             if (posMarkers[marker].getVisible()) { posMarkers[marker].setVisible(false); covMarkers[marker].setVisible(false); } 
             else { posMarkers[marker].setVisible(true); covMarkers[marker].setVisible(true); }
         }
    }});
    google.maps.event.addDomListener(greenportfm, 'click', function() { for (var marker in markers) {
         if (markers[marker].station == 'greenportfm') {
             if (posMarkers[marker].getVisible()) { posMarkers[marker].setVisible(false); covMarkers[marker].setVisible(false); } 
             else { posMarkers[marker].setVisible(true); covMarkers[marker].setVisible(true); }
         }
    }});
    google.maps.event.addDomListener(seldenfm, 'click', function() { for (var marker in markers) {
         if (markers[marker].station == 'seldenfm') {
             if (posMarkers[marker].getVisible()) { posMarkers[marker].setVisible(false); covMarkers[marker].setVisible(false); } 
             else { posMarkers[marker].setVisible(true); covMarkers[marker].setVisible(true); }
         }
    }});
    google.maps.event.addDomListener(northfordfm, 'click', function() { for (var marker in markers) {
             if (markers[marker].station == 'northfordfm') {
             if (posMarkers[marker].getVisible()) { posMarkers[marker].setVisible(false); covMarkers[marker].setVisible(false); } 
             else { posMarkers[marker].setVisible(true); covMarkers[marker].setVisible(true); }
             }
    }});
    google.maps.event.addDomListener(newhavenam, 'click', function() { for (var marker in markers) {
             if (markers[marker].station == 'newhavenam') {
             if (posMarkers[marker].getVisible()) { posMarkers[marker].setVisible(false); covMarkers[marker].setVisible(false); } 
             else { posMarkers[marker].setVisible(true); covMarkers[marker].setVisible(true); }
             }
    }});
    google.maps.event.addDomListener(westportam, 'click', function() { for (var marker in markers) {
         if (markers[marker].station == 'westportam') {
             if (posMarkers[marker].getVisible()) { posMarkers[marker].setVisible(false); covMarkers[marker].setVisible(false); } 
             else { posMarkers[marker].setVisible(true); covMarkers[marker].setVisible(true); }
         }
    }});
    google.maps.event.addDomListener(danburyfm, 'click', function() { for (var marker in markers) {
         if (markers[marker].station == 'danburyfm') {
             if (posMarkers[marker].getVisible()) { posMarkers[marker].setVisible(false); covMarkers[marker].setVisible(false); } 
             else { posMarkers[marker].setVisible(true); covMarkers[marker].setVisible(true); }
         }
    }});
    google.maps.event.addDomListener(derbyfm, 'click', function() { for (var marker in markers) {
         if (markers[marker].station == 'derbyfm') {
             if (posMarkers[marker].getVisible()) { posMarkers[marker].setVisible(false); covMarkers[marker].setVisible(false); } 
             else { posMarkers[marker].setVisible(true); covMarkers[marker].setVisible(true); }
         }
    }});
    google.maps.event.addDomListener(noyakfm, 'click', function() { for (var marker in markers) {
             if (markers[marker].station == 'noyakfm') {
             if (posMarkers[marker].getVisible()) { posMarkers[marker].setVisible(false); covMarkers[marker].setVisible(false); } 
             else { posMarkers[marker].setVisible(true); covMarkers[marker].setVisible(true); }
             }
    }});
    google.maps.event.addDomListener(noyak2fm, 'click', function() { for (var marker in markers) {
         if (markers[marker].station == 'noyak2fm') {
             if (posMarkers[marker].getVisible()) { posMarkers[marker].setVisible(false); covMarkers[marker].setVisible(false); } 
             else { posMarkers[marker].setVisible(true); covMarkers[marker].setVisible(true); }
         }
    }});
}
